import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import axios from "axios";

import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

createApp(App).use(router).use(VXETable).use(ElementPlus)
  .mount("#app");

axios.defaults.headers.post["Content-Type"] = "application/json";
